module.exports = __webpack_public_path__ + "media/mike4.be607e99.mp3";